<template>
  <a-modal title="" class="harvest-module" :visible="visible" @ok="onCofrim" @cancel="handleCancel">
    <div class="harvest-box">
      <div class="harvest-content">
          <img src="@/assets/image/tishi.png" alt="" class="image">
          <span>{{ data.btntext }}</span>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  name: "harvestModule",
  components: {},
  data() {
    return {
      visible: false,
      data:{},
    };
  },
  methods: {
    open(data) {
      this.data = data
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    onCofrim() {
      this.visible = false;
      this.$emit("btnOnCofrim",this.data);
    },
  },
  watch: {},
};
</script>
<style lang="scss">
.harvest-module {
  width: 520px !important;
  .harvest-box {
    padding: 60px 60px 40px 60px;
    .harvest-content {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .image {
        width: 24px;
        height: auto;
        margin-right: 8px;
    }
  }
  .ant-table-wrapper {
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
  .ant-modal-footer {
    padding: 0 0 48px 0;
  }
}
</style>
